import { TweenMax, Power2 } from 'gsap'
import axios from 'axios'

export function toggleHover(e, _self, cb, cb_param) {
	e.preventDefault()
	if (e.type === 'touchend' || e.type === 'touchstart') {
		if (typeof cb === 'function') {
			return cb(cb_param)
		} else {
			return
		}
	}

	if (e.type === 'mouseenter') {
		_self.setState({hover: 'hover'})
	}

	if (e.type === 'mouseleave') {
		_self.setState({hover: ''})
	}
}

export function scrollToTop(dur, cb) {
	let duration = 0.7
	let callback = null
	if (cb && typeof cb === 'function') {
		callback = cb
	}
	if (typeof dur === 'number') {
		duration = dur
	}
	TweenMax.to(window, duration, {scrollTo:0 ,ease: Power2.easeOut, onComplete:callback})
}

export function loadImage(url, cb) {
	let img = new Image()
	img.addEventListener('load', cb)
	img.src = url
}

export async function getLocation(lat,lng) {
	const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDb-cUEL4zk01KW8BDat1Cf4P07wak2gSQ`
	return await axios.get(url)
		.then(res => res.data)
		.then(res => {
			const array = res.results[0].address_components
			let town, region
			town = array.filter(v => v.types[0] === 'locality')[0].short_name
			region = array.filter(v => v.types[0] === 'administrative_area_level_1')[0].short_name
			return { town, region }
		})
		.catch(() => ({
			town: null,
			region: null
		}))
}


// WEBPACK FOOTER //
// /opt/build/repo/src/helpers.js